import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
const theme = {
    primary: '#0153CC',
    secondary: '#c3c3c3',
    accent: '#e91e63',
    info: '#00CAE3',
    success: '#4CAF50',
    warning: '#FB8C00',
    error: '#FF5252',
    background: '#EDF0F5',
}
export default new Vuetify({
    theme: {
        themes: {
            dark: theme,
            light: theme,
        },
    },
});
